import {Link} from 'react-router-dom'

const FormHeader = ({title, subTitle, link}) => {
  return (
    <div className='text-center mb-10'>
      <h1 className='text-dark mb-3'>{title}</h1>
      <div className='text-gray-400 fw-bold fs-4'>
        {subTitle}

        {link?.label && link?.to && (
          <Link to={link.to} className='link-primary fw-bolder'>
            {' '}
            {link.label}
          </Link>
        )}
      </div>
    </div>
  )
}

export default FormHeader
